/**
 * Fallback shown while Viewport3D lazy-loads. A dark pulsing box that
 * fills the entire viewport area, with a centred "3D" mono label.
 */
export default function ViewportSkeleton() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: 'var(--bg-base)',
        display: 'grid',
        placeItems: 'center',
        animation: 'ss-skeleton-pulse 1.6s ease-in-out infinite',
      }}
    >
      <style>{`
        @keyframes ss-skeleton-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.45; }
        }
      `}</style>
      <span
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: '2px',
          color: 'var(--text-hint)',
          userSelect: 'none',
        }}
      >
        3D
      </span>
    </div>
  );
}
